/* eslint-disable no-alert,consistent-return,import/extensions */
/* eslint-disable no-param-reassign */
import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { message, Modal } from "antd";
import { sortBy, uniqBy } from "lodash";
import { baseUrl } from "../../lib/routes/baseUrl";
import { getRoute } from "../../lib/routes";
import rtkRequestStatusCodes from "../../lib/const/rtkRequestStatusCodes";
import { buildQueryString, buildQueryStringWithObjectParams } from "../../lib/utils";
import Message from "../../components/Message/Message";
import {
  getServiceAgreementVersionsRoute,
  getServiceTypeVersionsRoute,
  getTariffsVersionsRoute,
  getGenericServicesRoute,
  updateServiceStatusRoute,
  changeServiceProfileRoute,
  getMassServicesRoute,
  getServicesBlockingTypeStatusRoute,
} from "../../lib/routes/services";
// import { exportToXLS } from "./xlsExport";

const initialState = {
  serviceBlockingStatus: [null],
  service: [],
  serviceTypes: [],
  serviceTypesByProductId: [],
  serviceDetails: {},
  serviceDetailsNames: [],
  serviceVersions: [],
  serviceTypeVersions: [],
  serviceTypeVersionsLoading: rtkRequestStatusCodes.idle,
  serviceAgreementsVersions: [],
  serviceAgreementsVersionsLoading: rtkRequestStatusCodes.idle,
  serviceTariffs: [],
  serviceTariffsLoading: rtkRequestStatusCodes.idle,
  serviceTariffsVersions: [],
  serviceTariffsVersionsLoading: rtkRequestStatusCodes.idle,
  serviceProfileVersions: [],
  defaultServiceNomenclature: [],
  serviceLoading: rtkRequestStatusCodes.idle,
  serviceTypesFetchingState: rtkRequestStatusCodes.idle,
  serviceTypesByProductIdFetchingState: rtkRequestStatusCodes.idle,
  serviceSearchingState: rtkRequestStatusCodes.idle,
  serviceDetailsLoading: rtkRequestStatusCodes.idle,
  servicesSearchingLoading: rtkRequestStatusCodes.idle,
  serviceDetailsFetchingState: rtkRequestStatusCodes.idle,
  servicesFetchingState: rtkRequestStatusCodes.idle,
  serviceVersionsLoading: rtkRequestStatusCodes.idle,
  serviceRateUpdatingState: rtkRequestStatusCodes.idle,
  serviceProfileVersionsLoading: rtkRequestStatusCodes.idle,
  defaultServiceNomenclatureLoading: rtkRequestStatusCodes.idle,
};

const fetchServiceByAggId = createAsyncThunk(
  "service/fetchServicesByAggId",
  async ({ agreementsIds, futureDates = true, ...queryParams }) => {
    try {
      let dataServices = [];
      await Promise.all(
        agreementsIds.map(async (agreementId) => {
          const queryString = buildQueryString({
            agreementId,
            includeFutureDates: futureDates,
            ...queryParams,
          });
          const url = getRoute("services-api", "services", `search?${queryString}`);
          const response = axios.get(url);
          const { data } = await response;
          if (response.length !== 0) {
            dataServices = [...dataServices, ...data];
          }
        })
      );
      const sortedArr = sortBy(dataServices, (o) => o.fromDate);
      return uniqBy(sortedArr, "id");
    } catch (e) {
      Message("Ошибка загрузки продуктов. Попробуйте позже", e);
    }
  }
);

const fetchServiceTypes = createAsyncThunk("service/fetchServiceTypes", async () => {
  const url = getRoute("offerings-api", "service-types");
  const { data } = await axios(url);
  return data;
});

const fetchServiceTypesByProductId = createAsyncThunk(
  "service/fetchServiceTypesByProductId",
  async (productId) => {
    const url =
      productId > 0
        ? getRoute("offerings-api", "service-types", `search?productId=${productId}`)
        : getRoute("offerings-api", "service-types");
    const { data } = await axios(url);
    return data;
  }
);

const searchServices = createAsyncThunk("service/searchServices", async (searchParams) => {
  try {
    const url = getMassServicesRoute(searchParams);
    const { data } = await axios(url);
    return uniqBy(data, "id");
  } catch (e) {
    Message("Ошибка загрузки данных. Попробуйте позже", e);
  }
});

// TODO refactoring Evgeniy - catch
const fetchServiceDetails = createAsyncThunk(
  "service/fetchServiceById",
  async ({ serviceId, onDate }) => {
    const queryString = buildQueryString({ onDate });
    const url = [getGenericServicesRoute("services", serviceId), queryString].join("?");
    try {
      const { data } = await axios(url);
      return data;
    } catch (e) {
      Modal.error({
        content: "Информация о продукте не найдена",
        onOk: () => {
          window.history.back();
        },
      });
      throw new Error(e);
    }
  }
);

const fetchServiceVersions = createAsyncThunk("service/fetchServiceVersions", async (serviceId) => {
  const url = getGenericServicesRoute("services", serviceId, "versions");
  try {
    const { data } = await axios(url);
    return data;
  } catch (e) {
    Modal.error({
      content: e.response?.data.message || "Что-то пошло не так...",
    });
    throw new Error(e);
  }
});

const updateService = createAsyncThunk(
  "service/updateService",
  // eslint-disable-next-line consistent-return
  async ({ service, queryParams }) => {
    const queryString = buildQueryString(queryParams);
    const { id, ...payload } = service;
    const url = [getGenericServicesRoute("services", `${id}?`), queryString].join("");
    try {
      message.loading("Обновление информации...", 0);
      const { data } = await axios.patch(url, payload);
      message.destroy();
      message.success("Информация обновлена");
      return data;
    } catch (e) {
      message.destroy();
      Modal.error({
        content: e.message || "Что-то пошло не так...",
      });
    }
  }
);

const changeServiceStatus = createAsyncThunk(
  "service/changeServiceStatus",
  async ({ serviceId, queryParams }) => {
    const queryString = buildQueryStringWithObjectParams(queryParams);
    const url = [getGenericServicesRoute("services", serviceId, "status?"), queryString].join("");
    try {
      message.loading("Обновление информации...", 0);
      const { data } = await axios.patch(url);
      message.destroy();
      message.success("Информация обновлена");
      return data;
    } catch (e) {
      message.destroy();
      Modal.error({
        content: e.message || "Что-то пошло не так...",
      });
    }
  }
);

const updateServiceMass = createAsyncThunk(
  "service/updateServiceMass",
  async ({ selectedServices, queryParams, serviceStatusIdNew }) => {
    const queryString = buildQueryString(queryParams);
    let count = 0;
    try {
      await Promise.all(
        selectedServices.map(async (item) => {
          const serviceWithNewStatus = { ...item, serviceStatusId: serviceStatusIdNew };
          const url = [getGenericServicesRoute("services", `${item.id}?`), queryString].join("");
          // eslint-disable-next-line no-plusplus
          count++;
          if (count === 1) {
            message.loading("Обновление информации...", 0);
          }
          const { data } = await axios.patch(url, serviceWithNewStatus);
          message.destroy();
          message.success("Информация обновлена");
          return data;
        })
      );
    } catch (e) {
      message.destroy();
      Modal.error({
        content: e.message || "Что-то пошло не так...",
      });
    }
  }
);

const deleteService = createAsyncThunk(
  "service/deleteService",
  async ({ serviceId, queryParams }) => {
    const queryString = buildQueryString(queryParams);
    const url = [getGenericServicesRoute("services", `${serviceId}?`), queryString].join("");
    message.loading("Закрытие продукта...");
    try {
      await axios.delete(url, serviceId);
      message.destroy();
      message.success("Продукт закрыт");
    } catch (e) {
      let errorMessage = "";
      if (e.response?.data?.message) {
        // Решили с Настей, что ввиду того что строка message с бэка должна содержать много вспомогательной информации
        // пробуем парсить ее по "message=", если получается - выводим это, нет - стандартное сообщение

        const responseMessage = e.response.data.message
          .split(",")
          .find((str) => str.includes("message="))
          ?.trim()
          .replace("message=", "");
        errorMessage = responseMessage || e.response.data.message;
      }
      message.destroy();
      Modal.error({
        title: "Ошибка изменения даты закрытия",
        content: errorMessage,
      });
    }
  }
);

const cancelService = createAsyncThunk("service/cancelService", async ({ serviceId, fromDate }) => {
  const queryString = buildQueryString({ fromDate });
  const url = [getGenericServicesRoute("services", serviceId, "cancel?"), queryString].join("");
  message.loading("Отмена продукта...");
  try {
    await axios.delete(url);
    message.destroy();
    message.success("Продукт отменен");
  } catch (e) {
    message.destroy();
    Modal.error({
      content: e.response.data.message || "Что-то пошло не так...",
    });
  }
});

const updateServiceProfile = createAsyncThunk(
  "service/updateServiceProfile",
  async ({ serviceProfile, queryParams }) => {
    const queryString = buildQueryString(queryParams);
    const url = [
      getRoute("offerings-api", "service-profiles", `${serviceProfile.id}?`),
      queryString,
    ].join("");
    try {
      message.loading("Обновлениние сервис профиля...");
      await axios.patch(url, serviceProfile);
      message.destroy();
      message.success("Профиль обновлен");
    } catch (e) {
      message.destroy();
      Modal.error({
        content: e.response?.data.message || "Что-то пошло не так...",
      });
    }
  }
);

const updateServiceStatus = createAsyncThunk(
  "service/updateServiceStatus",
  async ({ date, serviceStatusData }) => {
    const url = updateServiceStatusRoute(date);
    try {
      message.loading("Создание задания...");
      await axios.patch(url, serviceStatusData);
      message.destroy();
      message.success("Задание создано");
    } catch (e) {
      message.destroy();
      Modal.error({
        content: e.response?.data.message || "Ошибка создания",
      });
    }
  }
);
// const updateServiceTariff = createAsyncThunk(
//   "service/updateServiceTariff",
//   async ({ tariff, queryParams, serviceId }) => {
//     message.loading("Обновление параметров тарифа", 0);
//     const queryString = buildQueryString(queryParams);
//     const url = [
//       getGenericServicesRoute("services", `${serviceId}`, "tariffs?"),
//       queryString,
//     ].join("");
//     try {
//       await axios.patch(url, tariff);
//       message.destroy();
//       message.success("Информация обновлена");
//     } catch (e) {
//       message.destroy();
//       Modal.error({
//         content: e.response.data.message || "Что-то пошло не так",
//       });
//     }
//   }
// );

const updateServiceRate = createAsyncThunk(
  "service/updateServiceRate",
  async ({ serviceRate, fromDate = null, force = true }) => {
    const queryString = fromDate ? buildQueryString({ fromDate, force }) : "";
    const url = [getRoute("offerings-api", "service-rates", serviceRate.id), queryString].join("?");
    message.loading("Обновление информации...", 0);
    try {
      await axios.patch(url, serviceRate);
      message.destroy();
      message.success("Информация обновлена");
    } catch (e) {
      message.destroy();
      Modal.error({ content: e.message || "Что-то пошло не так... " });
    }
  }
);

const fetchServiceProfileVersions = createAsyncThunk(
  "service/fetchServiceProfileVersions",
  async (profileIds) => {
    try {
      const request = Promise.all(
        profileIds.map((profileId) => {
          const url = getRoute("offerings-api", "service-profiles", profileId, "versions");
          return axios.get(url);
        })
      );
      const res = await request;
      return res.map((item) => item.data);
    } catch (e) {
      Modal.error({
        content: e.response?.data.message || "Что-то пошло не так...",
      });
      throw new Error(e);
    }
  }
);

const fetchServiceTypeVersions = createAsyncThunk(
  "service/fetchServiceTypeVersions",
  async ({ serviceTypeIds }) => {
    try {
      const request = Promise.all(
        serviceTypeIds.map((serviceTypeId) => axios.get(getServiceTypeVersionsRoute(serviceTypeId)))
      );
      const res = await request;
      return res.map((item) => item.data);
    } catch (e) {
      Modal.error({
        content: e.response?.data.message || "Что-то пошло не так...",
      });
      throw new Error(e);
    }
  }
);

const fetchServiceAgreementVersions = createAsyncThunk(
  "service/fetchServiceAgreementVersions",
  async ({ serviceAgreementIds }) => {
    try {
      const request = Promise.all(
        serviceAgreementIds.map((agreementId) =>
          axios.get(getServiceAgreementVersionsRoute(agreementId))
        )
      );
      const res = await request;
      return res.map((item) => item.data);
    } catch (e) {
      Modal.error({
        content: e.response?.data.message || "Что-то пошло не так...",
      });
      throw new Error(e);
    }
  }
);

// TODO check Rostislav

const fetchServiceTariffVersions = createAsyncThunk(
  "service/fetchServiceTariffVersions",
  async (tariffIds) => {
    try {
      const request = Promise.all(
        tariffIds.map((tariffId) => axios.get(getTariffsVersionsRoute(tariffId)))
      );
      const res = await request;
      return res.map((item) => item.data);
    } catch (e) {
      Modal.error({
        content: e.response?.data.message || "Что-то пошло не так...",
      });
      throw new Error(e);
    }
  }
);

export const fetchServicesTariffsByIds = createAsyncThunk(
  "service/fetchServicesTariffsByIds",
  async (tariffs) => {
    const getUrl = ({ tariffId, onDate }) =>
      onDate
        ? getRoute("offerings-api", "tariffs", tariffId) + `?onDate=${encodeURIComponent(onDate)}`
        : getRoute("offerings-api", "tariffs", tariffId);

    return Promise.all(tariffs.map((tariff) => axios(getUrl(tariff))))
      .then((response) => response.map(({ data }) => data))
      .catch((e) =>
        Modal.error({
          content: e.response?.data?.message || "Ошибка загрузки тарифов...",
        })
      );
  }
);

export const fetchDefaultServiceNomenclature = createAsyncThunk(
  "service/fetchDefaultServiceNomenclature",
  async (serviceTypeId) => {
    try {
      const url = `${baseUrl}/dict-api/properties/service_type/${serviceTypeId}/versions?propertyType=default_charge_name`;
      const { data } = await axios(url);
      return data;
    } catch (e) {
      // eslint-disable-next-line no-console
      console.error("Ошибка получения значения по умолчанию Номенклатура для Типа цены", e);
      return [];
    }
  }
);

export const changeServiceProfile = createAsyncThunk(
  "service/changeServiceProfile",
  async ({ serviceId, fromDate, toDate, force, bodyRequest }) => {
    try {
      const url = changeServiceProfileRoute({ serviceId, fromDate, toDate, force });
      const { data } = await axios.patch(url, bodyRequest);
      message.success("Версия профиля успешно обновлёна");
      return data;
    } catch (e) {
      message.error("Ошибка обновления версии профиля");
    }
  }
);

export const fetchServicesBlockingTypeStatus = createAsyncThunk(
  "service/fetchServicesBlockingTypeStatus",
  async ({ objectTypeId, objectId, onDate }) => {
    try {
      const url = getServicesBlockingTypeStatusRoute({ objectTypeId, objectId, onDate });
      const { data } = await axios(url);
      return data;
    } catch (e) {
      console.log(e);
    }
  }
);

export const serviceSlice = createSlice({
  name: "service",
  initialState,
  reducers: {
    clearServices: {
      reducer: (state) => {
        state.service = [];
        state.serviceLoading = rtkRequestStatusCodes.idle;
      },
    },
    clearServiceTypesByProductId: {
      reducer: (state) => {
        state.serviceTypesByProductId = [];
        state.serviceTypesByProductIdFetchingState = rtkRequestStatusCodes.idle;
      },
    },
    clearServiceVersions: {
      reducer: (state) => {
        state.serviceVersions = [];
        state.serviceVersionsLoading = rtkRequestStatusCodes.idle;
      },
    },
    clearServiceTariffsVersions: {
      reducer: (state) => {
        state.serviceTariffsVersions = [];
        state.serviceTariffsVersionsLoading = rtkRequestStatusCodes.idle;
      },
    },
    clearServiceTypeVersions: {
      reducer: (state) => {
        state.serviceTypeVersions = [];
        state.serviceTypeVersionsLoading = rtkRequestStatusCodes.idle;
      },
    },
    clearServiceAgreementsVersions: {
      reducer: (state) => {
        state.serviceAgreementsVersions = [];
        state.serviceAgreementsVersionsLoading = rtkRequestStatusCodes.idle;
      },
    },
    clearServiceProfileVersions: {
      reducer: (state) => {
        state.serviceProfileVersions = [];
        state.serviceProfileVersionsLoading = rtkRequestStatusCodes.idle;
      },
    },
  },
  extraReducers: {
    [fetchServiceByAggId.fulfilled]: (state, action) => {
      state.service = action.payload;
      state.serviceLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchServiceByAggId.pending]: (state) => {
      state.serviceLoading = rtkRequestStatusCodes.pending;
    },
    [fetchServiceByAggId.rejected]: (state) => {
      state.serviceLoading = rtkRequestStatusCodes.rejected;
      state.service = [];
    },
    [fetchServiceTypes.fulfilled]: (state, { payload }) => {
      const sortedTypes = payload.sort((a, b) => a.name.localeCompare(b.name, "ru"));
      state.serviceTypes = sortedTypes;
      state.serviceTypesFetchingState = rtkRequestStatusCodes.fulfilled;
    },
    [fetchServiceTypes.pending]: (state) => {
      state.serviceTypesFetchingState = rtkRequestStatusCodes.pending;
    },
    [fetchServiceTypes.rejected]: (state) => {
      state.serviceTypesFetchingState = rtkRequestStatusCodes.rejected;
    },
    [fetchServiceTypesByProductId.fulfilled]: (state, { payload }) => {
      const sortedTypes = payload.sort((a, b) => a.name.localeCompare(b.name, "ru"));
      state.serviceTypesByProductId = sortedTypes;
      state.serviceTypesByProductIdFetchingState = rtkRequestStatusCodes.fulfilled;
    },
    [fetchServiceTypesByProductId.pending]: (state) => {
      state.serviceTypesByProductIdFetchingState = rtkRequestStatusCodes.pending;
    },
    [fetchServiceTypesByProductId.rejected]: (state) => {
      state.serviceTypesByProductIdFetchingState = rtkRequestStatusCodes.rejected;
    },
    [searchServices.fulfilled]: (state, action) => {
      state.service = action.payload;
      state.servicesSearchingLoading = rtkRequestStatusCodes.fulfilled;
    },
    [searchServices.pending]: (state) => {
      state.servicesSearchingLoading = rtkRequestStatusCodes.pending;
    },
    [searchServices.rejected]: (state) => {
      state.servicesSearchingLoading = rtkRequestStatusCodes.rejected;
    },
    [fetchServiceDetails.pending]: (state) => {
      state.serviceDetailsLoading = rtkRequestStatusCodes.pending;
    },
    [fetchServiceDetails.fulfilled]: (state, { payload }) => {
      state.serviceDetails = payload;
      state.serviceDetailsNames.push(state.serviceDetails);
      state.serviceDetailsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchServiceVersions.pending]: (state) => {
      state.serviceVersionsLoading = rtkRequestStatusCodes.pending;
    },
    [fetchServiceVersions.fulfilled]: (state, { payload }) => {
      const sortedVersions = payload
        .flat()
        .sort((a, b) => +new Date(b.fromDate) - +new Date(a.fromDate));
      state.serviceVersions = sortedVersions;
      state.serviceVersionsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchServiceProfileVersions.pending]: (state) => {
      state.serviceProfileVersionsLoading = rtkRequestStatusCodes.pending;
    },
    [fetchServiceProfileVersions.fulfilled]: (state, { payload }) => {
      const sortedVersions = payload
        .flat()
        .sort((a, b) => +new Date(b.fromDate) - +new Date(a.fromDate));
      state.serviceProfileVersions = sortedVersions;
      state.serviceProfileVersionsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [updateService.rejected]: (_state, action) => {
      Message(action.error.message);
    },
    [fetchServiceTypeVersions.fulfilled]: (state, { payload }) => {
      state.serviceTypeVersions = payload;
      state.serviceTypeVersionsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchServiceTypeVersions.rejected]: (state) => {
      state.serviceTypeVersionsLoading = rtkRequestStatusCodes.rejected;
    },
    [fetchServiceTypeVersions.pending]: (state) => {
      state.serviceTypeVersionsLoading = rtkRequestStatusCodes.pending;
    },
    [fetchServiceAgreementVersions.fulfilled]: (state, { payload }) => {
      const sortedVersions = payload
        .flat()
        .sort((a, b) => +new Date(b.fromDate) - +new Date(a.fromDate));
      state.serviceAgreementsVersions = sortedVersions;
      state.serviceAgreementsVersionsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchServiceAgreementVersions.rejected]: (state) => {
      state.serviceAgreementsVersionsLoading = rtkRequestStatusCodes.rejected;
    },
    [fetchServiceAgreementVersions.pending]: (state) => {
      state.serviceAgreementsVersionsLoading = rtkRequestStatusCodes.pending;
    },
    [fetchServiceTariffVersions.fulfilled]: (state, { payload }) => {
      const sortedVersions = payload
        .flat()
        .sort((a, b) => +new Date(b.fromDate) - +new Date(a.fromDate));
      state.serviceTariffsVersions = sortedVersions;
      state.serviceTariffsVersionsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchServiceTariffVersions.rejected]: (state) => {
      state.serviceTariffsVersionsLoading = rtkRequestStatusCodes.rejected;
    },
    [fetchServiceTariffVersions.pending]: (state) => {
      state.serviceTariffsVersionsLoading = rtkRequestStatusCodes.pending;
    },
    [fetchServicesTariffsByIds.pending]: (state) => {
      state.serviceTariffsLoading = rtkRequestStatusCodes.pending;
    },
    [fetchServicesTariffsByIds.fulfilled]: (state, { payload }) => {
      state.serviceTariffs = payload;
      state.serviceTariffsLoading = rtkRequestStatusCodes.fulfilled;
    },
    [fetchServicesTariffsByIds.rejected]: (state) => {
      state.serviceTariffsLoading = rtkRequestStatusCodes.rejected;
    },
    [fetchDefaultServiceNomenclature.pending]: (state) => {
      state.defaultServiceNomenclatureLoading = rtkRequestStatusCodes.pending;
    },
    [fetchDefaultServiceNomenclature.fulfilled]: (state, { payload }) => {
      const sortedData = payload.sort((a, b) => a.type.name.localeCompare(b.type.name, "ru"));
      state.defaultServiceNomenclatureLoading = rtkRequestStatusCodes.fulfilled;
      state.defaultServiceNomenclature = sortedData;
    },
    [fetchDefaultServiceNomenclature.rejected]: (state) => {
      state.defaultServiceNomenclatureLoading = rtkRequestStatusCodes.rejected;
      state.defaultServiceNomenclature = [];
    },
    [fetchServicesBlockingTypeStatus.fulfilled]: (state, { payload }) => {
      state.serviceBlockingStatus = payload;
    },
  },
});

const { reducer, actions } = serviceSlice;
const { clearServices, clearServiceTypesByProductId } = actions;

export {
  actions,
  fetchServiceByAggId,
  fetchServiceTypes,
  fetchServiceTypesByProductId,
  searchServices,
  fetchServiceDetails,
  updateService,
  deleteService,
  cancelService,
  updateServiceProfile,
  updateServiceRate,
  fetchServiceVersions,
  fetchServiceProfileVersions,
  fetchServiceTypeVersions,
  fetchServiceAgreementVersions,
  fetchServiceTariffVersions,
  reducer,
  updateServiceStatus,
  updateServiceMass,
  clearServices,
  changeServiceStatus,
  clearServiceTypesByProductId,
};
